import { TRPCClientError } from '@trpc/client';
import { isTransient } from '@/api/isTransientError';

const MAX_RETRIES = 2;
const DEFAULT_BUSY_WAIT_MS = 10_000;
const MAX_AUTOMATIC_WAIT_MS = 60_000;

export function isIdeaLabPreviewBusy(error: unknown): boolean {
    if (!(error instanceof TRPCClientError)) return false;
    const data: unknown = error.data;
    return typeof data === 'object' && data !== null && 'code' in data && data.code === 'SERVICE_UNAVAILABLE';
}

export function ideaLabPreviewRetryDelay(attempt: number, error: unknown): number {
    if (isIdeaLabPreviewBusy(error) && error instanceof TRPCClientError) {
        const data: unknown = error.data;
        if (typeof data === 'object' && data !== null && 'retryAfterSeconds' in data) {
            const seconds = data.retryAfterSeconds;
            if (typeof seconds === 'number' && Number.isFinite(seconds) && seconds > 0) return seconds * 1000;
        }
        return DEFAULT_BUSY_WAIT_MS;
    }
    return Math.min(1000 * 2 ** attempt, MAX_AUTOMATIC_WAIT_MS);
}

export function retryIdeaLabPreview(failureCount: number, error: unknown): boolean {
    return failureCount < MAX_RETRIES && isTransient(error) && ideaLabPreviewRetryDelay(failureCount, error) <= MAX_AUTOMATIC_WAIT_MS;
}
